export enum MessageTypes {
    JoinSeat = 1,
    LeaveSeat = 2,
    LeaveALL = 3,
    SyncMessage = 4,
}